import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../img/logoUtility.png'


const _hoisted_1 = {
  id: "sidebar",
  class: "col-1 col-md-3 col-lg-2 d-none d-sm-block sidebar p-0"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "sidebar-header p-3" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "",
    width: "",
    class: "",
    style: {"width":"150px","background-color":"transparent!important"}
  })
], -1)
const _hoisted_3 = { class: "list-unstyled components" }
const _hoisted_4 = { class: "" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-xs-5 col-sm-5 col-md-5 col-lg-4" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "col-xs-7 col-sm-7 col-md-7 col-lg-8" }
const _hoisted_9 = {
  id: "nombreUsuario",
  style: {"font-size":"13px!important"}
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = {
  id: "apellidosUsuario",
  style: {"font-size":"13px!important"}
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", {
  id: "nombreEmpresa",
  style: {"font-size":"14px!important","color":"#2b2b2b"}
}, " Agua de México ", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_15 = {
  key: 0,
  class: "menu_l"
}
const _hoisted_16 = { class: "list-group text-start border-0" }
const _hoisted_17 = { class: "list-group-item border-0 p-0" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Mensajes")
const _hoisted_19 = { class: "list-group-item border-0 p-0" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode("Archivos")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("ul", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("img", {
              src: _ctx.imgUser(_ctx.user.picture),
              style: {"width":"80px","height":"auto","padding-left":"10px"},
              alt: ""
            }, null, 8, _hoisted_7)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.user.name), 1),
            _hoisted_10,
            _createElementVNode("span", _hoisted_11, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.user.profiles, (adm) => {
                return (_openBlock(), _createElementBlock("span", null, _toDisplayString(adm), 1))
              }), 256))
            ]),
            _hoisted_12,
            _hoisted_13
          ])
        ])
      ]),
      _hoisted_14
    ]),
    (_ctx.mostrarMenu)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createElementVNode("ul", _hoisted_16, [
            _createElementVNode("li", _hoisted_17, [
              _createVNode(_component_router_link, { to: "/main" }, {
                default: _withCtx(() => [
                  _hoisted_18
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_19, [
              _createVNode(_component_router_link, { to: "/files" }, {
                default: _withCtx(() => [
                  _hoisted_20
                ]),
                _: 1
              })
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}